<script>
import DatePicker from "vue2-datepicker";
import ModalWindow from "./ModalWindow.vue";
import {errors} from "braintree-web-drop-in/constants";

const initialDownload = {
    title: '',
    download_date: '',
    download_link: '',
    file: null,
    image: null,
    content: {
        image: null
    },
    type: 'download'
}

export default {
    name: "ModalAddDownload",

    components: {ModalWindow, DatePicker},

    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        initialData: {
            type: Object,
            default: () => {
                return {...initialDownload}
            }
        }
    },

    data() {
        return {
            download: this.initialData,
            input: null,
            image_preview: {
                url: null,
            },
            filename: 'File',
            image: null,
            errors: {}
        }
    },

    methods: {
        onChangeFile() {
            const files = this.$refs.input.files
            const file = files[0]
            this.download.file = file
            this.filename = file.name
        },
        onChangeImage() {
            const files = this.$refs.image.files
            const image = files[0]

            if (!this.validateImage(image)) {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: 'Error while uploading image'
                })
            } else {
                let item = {
                    url: '',
                    file: image,
                }
                let reader = new FileReader();
                reader.onload = (e) => {
                    item.url = this.download.content.image = e.target.result
                }
                reader.readAsDataURL(image);
                this.image_preview = item
                this.download.image = image
            }
        },
        validateImage(file) {
            let accept_images = [
                'image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml',
            ]

            return accept_images.includes(file.type);
        },
        validateInput() {
            let isValid = true

            if (!this.download.title) {
                this.errors.title = 'Title is required field'
                isValid = false;
            }
            // if (!this.download.download_date) {
            //     this.errors.download_date = 'Date is required field'
            //     isValid = false;
            // }
            if (!this.download.image) {
                this.errors.image = 'Image is required field'
                isValid = false;
            }
            if (!this.download.file) {
                this.errors.file = 'File is required field'
                isValid = false;
            }

            return isValid;


        },
        save() {
            this.errors = {}
            console.log('!this.validateInput()', !this.validateInput())
            if (!this.validateInput()) {
                return
            }
            this.$emit('onSave', {...this.download})
            this.download = {...initialDownload}
            this.filename = 'File'
            this.image_preview ={
                url: null
            }
            this.$refs.input.value = null
            this.$refs.image.value = null
            this.$emit('onModalClose')
        },
        dragoverInput(event) {
            event.currentTarget.classList.add('over');
        },
        dragleaveInput(event) {
            event.currentTarget.classList.remove('over');
        },
        dropImage(event) {
            event.currentTarget.classList.remove('over')
            event.preventDefault()
            this.$refs.image.files = event.dataTransfer.files

            this.onChangeImage()
        },
        dropFile(event) {
            event.currentTarget.classList.remove('over')
            event.preventDefault()

            this.$refs.input.files = event.dataTransfer.files

            this.onChangeFile()
        },
    }
}
</script>

<template>
    <ModalWindow :open="isOpen" @closeModal="$emit('onModalClose')">
        <template #title>
            Add download
        </template>

        <template #body>
            <div class="formBlock">
                <p class="label">Title</p>
                <input type="text" class="input"
                       required
                       v-model="download.title"
                       placeholder="Download title">
                <p class="errorNotify" v-if="errors.title">{{ errors.title }}</p>
            </div>
            <div class="formBlock">
                <p class="label">Document Date</p>
                <DatePicker
                    type="date"
                    valueType="format"
                    format="MM/DD/YYYY"
                    v-model="download.download_date"
                    placeholder="Download Date"
                />
                <p class="errorNotify" v-if="errors.download_date">{{ errors.download_date }}</p>
                <p class="help">Example: 05/20/2022</p>
            </div>
            <div class="formBlock">
                <p class="label">Image</p>
                <div class="flex-row flex-row-image" style="align-items: center;">
                    <div class="avatar image-cover"
                         :style="`flex-shrink:0; background-image: url(${image_preview.url ? image_preview.url : '/images/no_image.svg'});`"></div>
                    <label for="image" class="drag-in-drop"
                           style="display: flex"
                           @dragover.prevent="dragoverInput"
                           @dragleave.prevent="dragleaveInput"
                           @drop="(e) => dropImage(e)">
                        <input type="file"
                               @change="onChangeImage"
                               id="image"
                               ref="image"
                               accept=".jpeg,.jpg,.png,.gif"/>
                        <span class="label">Image</span>
                    </label>
                </div>
                <p class="errorNotify" v-if="errors.image">{{ errors.image }}</p>
            </div>
            <div class="formBlock">
                <p class="label">File</p>
                <div class="">
                    <label for="input" class="drag-in-drop"
                           style="display: flex;align-items: center;justify-content: center"
                           @dragover.prevent="dragoverInput"
                           @dragleave.prevent="dragleaveInput"
                           @drop="(e) => dropFile(e)">
                        <input type="file"
                               id="input"
                               class="input"
                               ref="input"
                               @change="onChangeFile"
                               placeholder="Download file">
                        <span class="label">{{ filename }}</span>
                    </label>
                </div>
                <p class="errorNotify" v-if="errors.file">{{ errors.file }}</p>
            </div>
        </template>

        <template #buttons>
            <button @click="save" class="button btn-primary">Save</button>
        </template>
    </ModalWindow>
</template>

<style>
.errorNotify {
    color: #a31515;
}
</style>
